module.exports = __webpack_public_path__ + "media/images/herospark_logo-541272d2eac67a502d24cca4e117b263.svg";